import ThumbsUpIcon from '@svg/thumbs-up.svg';
import ThumbsUpFilledIcon from '@svg/thumbs-up-filled.svg';
import { Image } from '@ui/Image';
import { Button } from '@ui/Button';
import { useSocailPostLikeToggle } from '@hook/useSocailPostLikeToggle';

import s from './ProductDetailsPostCard.sss';

interface SocialPostAuthor {
  id: number,
  username: string,
  avatar: string,
}

export interface SocialPost {
  id: string,
  isLiked: boolean,
  description: string,
  likesCount: number,
  mediasUrls: string[],
  author: SocialPostAuthor,
}

interface Props {
  post: SocialPost,
}

export const ProductDetailsPostCard: React.FC<Props> = ({
  post,
}) => {
  const {
    handleLikePost,
    handleUnlikePost,
    isLoading,
  } = useSocailPostLikeToggle(post);

  const handleToggleLikePost = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    e.preventDefault();

    if (post.isLiked) {
      handleUnlikePost();
    } else {
      handleLikePost();
    }
  };

  return (
    <article className={s.root}>
      <div className={s.thumbnailHolder}>
        <Image
          className={s.thumbnail}
          src={post.mediasUrls[0]}
          width="200"
          height="280"
          lazy={true}
        />
      </div>

      <div className={s.author}>
        <Image
          className={s.avatar}
          src={post.author.avatar}
          width="24"
          height="24"
          lazy={true}
        />

        <p className={s.username}>
          {post.author.username}
        </p>

        <Button
          className={s.likes}
          theme="text"
          disabled={isLoading}
          onClick={handleToggleLikePost}
        >
          {post.likesCount}

          {post.isLiked ? (
            <ThumbsUpFilledIcon
              widths="24"
              height="24"
            />
          ) : (
            <ThumbsUpIcon
              widths="24"
              height="24"
            />
          )}
        </Button>
      </div>

      <p className={s.description}>
        {post.description}
      </p>
    </article>
  );
};
